import React from "react";
import { BsChatText } from "react-icons/bs";
import { IoMdTime,IoIosGlobe } from "react-icons/io";
import { FaRegUserCircle } from "react-icons/fa";
import { IoLocationOutline } from "react-icons/io5";
import { FaRegUser } from "react-icons/fa";
import { CiMobile1,CiLaptop } from "react-icons/ci";
import { FiTablet } from "react-icons/fi";
import { FaTv,FaWindows,FaApple,FaLinux,FaSafari,FaChrome} from "react-icons/fa";
import { FaBrave } from "react-icons/fa6";
import { GoDependabot } from "react-icons/go";

const LiveViewModal = ({ user, onClose }) => {
  if (!user) return null;

  const formatTime = (active_time) => {
    const minutes = Math.floor(active_time / 60);
    return `${minutes} min`;
  };

  return (
    <div
      className="absolute bg-white transform -translate-x-1/2 bg-whiteshadow-lg rounded-xl w-96"
      onClick={(e) => e.stopPropagation()}
    >
      {/* Header */}
      <div className="flex items-center bg-gray-100 px-4 py-2 rounded-xl gap-3 mb-2">
        <div className="w-10 h-10 bg-gray-200 rounded-full flex items-center justify-center">
          <FaRegUser className="w-5 h-5 text-gray-500" />
        </div>
        <div>
          <div className="flex items-center gap-2">
            <span className="font-medium">{user.id}</span>
            <span className="text-base text-gray-500">{user.country_flag}</span>
            <span className="text-base text-gray-500">{user.device === "is_mobile" ? <CiMobile1/> : user.device === "is_tablet" ? <FiTablet/> : user.device === "is_desktop" ? <CiLaptop/> : user.device === "is_smart_tv" ? <FaTv/> : <GoDependabot/>}</span>
            <span className="text-sm text-gray-500">{user.browser=== "safari" ? <FaSafari/> : user.device === "brave" ? <FaBrave/> : <FaChrome/>}</span>
            <span className="text-sm text-gray-500">{user.os=== "mac" ? <FaApple/> : user.device === "linux" ? <FaLinux/> : <FaWindows/>}</span>
          </div>
          <div className="text-sm text-gray-500">
            {user.city}, {user.region}, {user.country}
          </div>
        </div>
      </div>

      <div className="p-4 ">
        {/* Stats Grid */}
        <div className="flex flex-row">
          <div className="flex flex-col items-center border-r-2 border-gray-200 pr-3 gap-2">
            <FaRegUserCircle  className="w-5 h-5 text-gray-400" />
            <span className="text-sm">{user.customer_type}</span>
          </div>
          <div className="flex flex-col items-center border-r-2 border-gray-200 px-3 gap-2">
            <IoMdTime className="w-5 h-5 text-gray-400" />
            <span className="text-sm">{formatTime(user.active_time)}</span>
          </div>
          <div className="flex flex-col items-center border-r-2 border-gray-200 px-3 gap-2">
            <BsChatText className="w-5 h-5 text-gray-400" />
            <span className="text-sm">0/0</span>
          </div>
          <div className="col-span-3 flex flex-col border-gray-200 px-3 items-center gap-2">
            <IoLocationOutline className="w-5 h-5 text-gray-400" />
            <span className="text-sm font-mono">{user.ip}</span>
          </div>
          {/* <div className="flex flex-col items-center border-r-2 border-gray-200 px-3 gap-2">
            <Share2 className="w-4 h-4 text-gray-400" />
            <span className="text-sm">0/0</span>
          </div> */}
          {user.url && (
            <div className="col-span-3 flex items-center gap-2">
              <IoIosGlobe className="w-4 h-4 text-gray-400" />
              <a
                href={user.url}
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-blue-500 hover:underline truncate"
              >
                {user.url}
              </a>
            </div>
          )}
        </div>

        {/* Timeline */}
        <div className="flex flex-col items-start gap-3 mt-4 pt-4">
          <div className="w-full flex flex-row items-center gap-1 -mt-4">
            <div className="text-sm text-gray-500">Today</div>
            <div className="h-0.5 bg-gray-200 w-full"></div>
          </div>
          <div className="flex  items-center gap-2">
            <div className="flex gap-3 items-center">
              <div className="text-xs text-gray-400">11:34</div>
              <div className="w-2 h-2 rounded-full bg-gray-300" />
              <div className="text-sm text-gray-400">
                Our Impact - Red Sea Mall
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LiveViewModal;
